import { Button } from "@/components/ui/button"
import { Sheet, SheetContent, SheetSection, SheetTrigger } from "@/components/ui/sheet"

export function SheetPreviewRoute(): JSX.Element {
  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">Sheet</h1>
      </header>

      <Section title="Right side">
        <Sheet>
          <SheetTrigger asChild>
            <Button>Open sheet</Button>
          </SheetTrigger>
          <SheetContent
            side="right"
            title="Sheet title"
            description="Slides in from the right."
          >
            <SheetSection title="Section one">
              <p className="text-body-sm text-text-2">
                A titled block inside the sheet with consistent padding.
              </p>
            </SheetSection>
            <SheetSection title="Section two">
              <p className="text-body-sm text-text-2">Another block below.</p>
            </SheetSection>
          </SheetContent>
        </Sheet>
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-3.5">{children}</div>
    </section>
  )
}
